import PropTypes from 'prop-types';
import {
  darkModeContext as DarkModeContext,
  darkModeActionContext as DarkModeActionContext,
} from './darkModeContext';
import useDarkMode from './useDarkMode';

const DarkModeProvider = ({ children }) => {
  const { isDarkMode, changeMode } = useDarkMode();

  return (
    <DarkModeActionContext.Provider value={changeMode}>
      <DarkModeContext.Provider value={isDarkMode}>
        {children}
      </DarkModeContext.Provider>
    </DarkModeActionContext.Provider>
  );
};

DarkModeProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default DarkModeProvider;
